import D2C_Entity from './Entity'
import logger from '@/logger'
import objects from '@/objects'
import store from '@/store'

class D2C_Tariff extends D2C_Entity {
  target = 'tariff'
  icon = 'user'
  isFree = false
  static fields = {
    name: {
      default: 'Unknown'
    },
  }
  static create(props = {}) {
    const Constructor = objects._tariffsById[props.id]
    if (Constructor) {
      return new Constructor(props)
    }
    if (props.id) {
      logger.warning(`🚨 Unknown tariff id: ${props.id}`)
    }
    return new D2C_Tariff(props)
  }
  get _options() {
    return store.getters.tariffs.filter(tariff => tariff.type === 'option' && tariff.availableFor.includes(this.id))
  }
}

export default D2C_Tariff
